export default function AssetDisplayElement(props:{title: string, value: string}) {
    return (
        <div className="py-1 lg:py-2 lg:grid lg:grid-cols-5 lg:gap-2">
            <dt className="text-sm font-medium lg:font-normal text-gray-500 lg:col-span-2 text-ellipsis overflow-hidden">{props.title}</dt>
            <dd className="font-mono mt-1 text-sm text-gray-900 lg:mt-0 lg:col-span-3 text-ellipsis overflow-hidden">{props.value}</dd>
        </div>
    )
}